module.exports = __webpack_public_path__ + "img/bicycleFrontLeftOutline.e8fba2cc.svg";